import script from "./WorkModes.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkModes.vue?vue&type=script&setup=true&lang=ts"

import "./WorkModes.vue?vue&type=style&index=0&id=ea7bdac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea7bdac8"]])

export default __exports__